(function () {
  function esc(s) {
    return (s || "").toString().replace(/"/g, "&quot;");
  }

  // ✅ Imposta qui il tuo Worker (uguale per tutti i box)
  const WORKER_BASE =
    "https://delicate-sun-a9ab.giannitritella.workers.dev/?asin=";

  // ✅ Metti qui il tuo tag affiliato (serve solo per fallback link)
  const DEFAULT_TAG = "giannitritell-21";

  // Cache semplice per non fare fetch ripetuti se lo stesso ASIN appare più volte
  const cache = new Map();

  function buildFallbackUrl(asin, tag) {
    if (!asin) return "#";
    const t = tag || DEFAULT_TAG;
    return `https://www.amazon.it/dp/${asin}?tag=${encodeURIComponent(t)}`;
  }

  function renderBox(el, data) {
    const asin = el.getAttribute("data-asin") || "";

    // Fallback presi dagli attributi del div
    const fallbackTitle = el.getAttribute("data-title") || "Caricamento prodotto…";
    const fallbackDesc =
      el.getAttribute("data-desc") || "Prezzo e disponibilità aggiornati su Amazon.";
    const fallbackImg = el.getAttribute("data-img") || "";
    const fallbackTag = el.getAttribute("data-tag") || DEFAULT_TAG;

    // Fallback URL: se metti data-url lo usiamo, altrimenti dp/asin?tag=
    const attrUrl = el.getAttribute("data-url") || "";
    const fallbackUrl = attrUrl || buildFallbackUrl(asin, fallbackTag);

    // Dati da API (Worker) — compatibili con il tuo output: title, image, url
    const title = (data && data.title) || fallbackTitle;
    const desc = (data && (data.desc || data.description)) || fallbackDesc;
    const img = (data && (data.image || data.img)) || fallbackImg;
    const url = (data && data.url) || fallbackUrl;

    el.innerHTML = `
<div style="background:#fff;border:1px solid #e5e7eb;border-radius:10px;padding:14px;display:flex;gap:14px;align-items:center;box-shadow:0 4px 16px rgba(0,0,0,.06);margin:20px 0;">
  ${img ? `<img src="${img}" alt="${esc(title)}" style="width:110px;height:auto;border-radius:8px;flex-shrink:0;">` : ``}
  <div style="flex:1;">
    ${title ? `<h3 style="font-size:18px;margin:0 0 8px;">${title}</h3>` : ``}
    ${desc ? `<p style="margin:0 0 10px;font-size:14px;color:#555;">${desc}</p>` : ``}
    <a href="${url}" rel="nofollow noopener" style="background:#fbbf24;color:#111;padding:10px 14px;border-radius:8px;text-decoration:none;display:inline-block;font-weight:bold;" target="_blank">
      🛒 Acquista ora su Amazon
    </a>
  </div>
</div>`;
  }

  async function fetchFromWorker(asin) {
    if (!asin) return null;
    if (cache.has(asin)) return cache.get(asin);

    const p = (async () => {
      const endpoint = WORKER_BASE + encodeURIComponent(asin);
      const res = await fetch(endpoint, { method: "GET" });
      if (!res.ok) return null;
      const data = await res.json();
      return data && typeof data === "object" ? data : null;
    })();

    cache.set(asin, p);
    return p;
  }

  async function init() {
    const boxes = document.querySelectorAll(".amazon-box[data-asin]");
    if (!boxes.length) return;

    // Render immediato con fallback (così il box appare subito)
    boxes.forEach((el) => renderBox(el, null));

    // Aggiorna con i dati reali dal Worker
    for (const el of boxes) {
      const asin = el.getAttribute("data-asin");
      try {
        const data = await fetchFromWorker(asin);
        if (data) renderBox(el, data);
      } catch (e) {
        // Se fallisce, resta il fallback (non rompiamo la pagina)
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
